export function mapEvaluateOperator(node, ctx) {
    const funcNode = ctx.getChild(node, "FunctionCall");
    if (!funcNode)
        return ctx.errorNode(node, "Evaluate missing plugin call");
    const call = ctx.mapFunctionCall(funcNode);
    if (call.type === "ErrorNode")
        return call;
    return {
        type: "EvaluateOperator",
        plugin: call,
        start: node.from,
        end: node.to,
    };
}
